"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.palette = void 0;
exports.palette = {
    white: {
        100: '#FFFFFF'
    },
    primaryColorNeutralGray: {
        100: '#161616',
        90: '#262626',
        80: '#393939',
        70: '#525252',
        60: '#6F6F6F',
        50: '#8D8D8D',
        40: '#A8A8A8',
        30: '#C6C6C6',
        20: '#E0E0E0',
        10: '#F4F4F4'
    },
    virilisGreen: {
        100: '#001A09',
        90: '#00461A',
        80: '#006F2A',
        70: '#00933C',
        60: '#00B44D',
        50: '#00D15F',
        40: '#39DB83',
        30: '#72E6A6',
        20: '#AAF0CA',
        10: '#E3FAED'
    },
    primaryColorMineralGrey: {
        100: '#121416',
        90: '#272B2F',
        80: '#3B4148',
        70: '#505861',
        60: '#6A7178',
        50: '#848A90',
        40: '#9EA2A7',
        30: '#B8BBBF',
        20: '#D2D4D6',
        10: '#ECEDEE'
    },
    blue: {
        100: '#00115C',
        90: '#002085',
        80: '#0034AD',
        70: '#004BD6',
        60: '#0066FF',
        50: '#2985FF',
        40: '#52A2FF',
        30: '#7ABDFF',
        20: '#A3D5FF',
        10: '#CCEAFF'
    },
    ignis: {
        100: '#330000',
        90: '#5C0000',
        80: '#850007',
        70: '#AD0314',
        60: '#D61426',
        50: '#ED2B3D',
        40: '#F15B5D',
        30: '#F5918A',
        20: '#F9C2BA',
        10: '#FDEEEA'
    },
    suma: {
        100: '#331800',
        90: '#5C2D00',
        80: '#854200',
        70: '#AD590C',
        60: '#D6711F',
        50: '#FE8A39',
        40: '#FEB666',
        30: '#FFD792',
        20: '#FFEFBF',
        10: '#FFFCEB'
    }
};
//# sourceMappingURL=palette.js.map